
export default {
    namespaced: true,
    state: {
        usersData: [],
        isFail: false,
        isLoad: false,
        forSaveUsers: [],
        roles: [],
        editToggle: {}

    },
    getters: {
        ROLES: state => {
            return state.roles;
        },
        EDIT_TOGGLE: state => {
            return state.editToggle;
        },
        FOR_SAVE_USERS: state => {
            return state.forSaveUsers;
        },
        IS_LOAD: state => {
            return state.isLoad;
        },
        IS_FAIL: state => {
            return state.isFail;
        },
        USERS_DATA: state => {
            return state.usersData;
        }
    },
    mutations: {
        EDIT_TOGGLE: (state, payload) => {
            return state.editToggle = payload;
        },
        ROLES: (state, payload) => {
            return state.roles = payload;
        },
        FOR_SAVE_USERS: (state, payload) => {
            return state.forSaveUsers = payload;
        },
        IS_LOAD: (state, payload) => {
            return state.isLoad = payload;
        },
        IS_FAIL: (state, payload) => {
            return state.isFail = payload;
        },
        USERS_DATA: (state, payload) => {
            return state.usersData = payload;
        }
    },
    actions: {
        GET_ALL: async ({state, rootGetters }) => {
            state.isLoad = true;
            let {data} = await rootGetters.getHttpClient.get('/users/get');
            state.isLoad = false;
            if (data.status == 'success') {
                state.isFail = false;
                for (let key in data.usersData) {
                    data.usersData[key]['action'] = '';
                }
                state.usersData = data.usersData;
            } else {
                state.isFail = true;
            }
        },
        GET_ROLES: async ({state, rootGetters }) => {
            state.isLoad = true;
            let {data} = await rootGetters.getHttpClient.get('/users/get-roles');
            state.isLoad = false;
            if (data.status == 'success') {
                state.isFail = false;
                state.roles = data.rolesData;
            } else {
                state.isFail = true;
            }
        },
        SAVE: async ({state, commit, dispatch, rootGetters }) => {
            await rootGetters.getHttpClient.post('/users/save', state.forSaveUsers
            ).then(function(response) {
                let responseData = response.data;
                if (responseData.status == 'success') {
                    state.forSaveUsers = {};
                    dispatch('GET_ALL');
                    commit('setInfoText', 'Данные сохранены!', {root: true});
                    rootGetters.getBvModal.show('infoMessage');
                } else {
                    // show error
                    commit('setErrorText', responseData.errorInfo, {root: true});
                    rootGetters.getBvModal.show('errorResponse');
                }
            }).catch(function(error) {
                commit('setErrorText', error.toString(), {root: true});
                rootGetters.getBvModal.show('errorResponse');
            });
        }
    }
}